import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class DateServiceProvider {
  constructor() {}

  DateAndTimeToFormattedString(x) {
    let d = new Date(x);
    var yyyy = d.getUTCFullYear();
    var mm = d.getUTCMonth() + 1; // getMonth() is zero-based
    var dd = d.getUTCDate();
    var hours = d.getUTCHours();
    var minutes = d.getUTCMinutes();
    var ss = d.getUTCSeconds();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    let newMinutes = minutes < 10 ? "0" + minutes : minutes;
    let newSS = ss < 10 ? "0" + ss : ss;
    var strDate = mm + "/" + dd + "/" + yyyy + " ";
    var strTime =
      hours + ":" + newMinutes + ":" + newSS + " " + ampm.toUpperCase();

    return strDate.toString() + strTime.toString();
  }

  DateAndTimeToFormattedStringNoUTC(x) {
    let d = new Date(x);
    var yyyy = d.getFullYear();
    var mm = d.getMonth() + 1; // getMonth() is zero-based
    var dd = d.getDate();
    var hours = d.getHours();
    var minutes = d.getMinutes();
    var ss = d.getSeconds();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    let newMinutes = minutes < 10 ? "0" + minutes : minutes;
    let newSS = ss < 10 ? "0" + ss : ss;
    var strDate = mm + "/" + dd + "/" + yyyy + " ";
    var strTime =
      hours + ":" + newMinutes + ":" + newSS + " " + ampm.toUpperCase();

    return strDate.toString() + strTime.toString();
  }

  convertDateTime(dt) {
    return (
      dt.toString().split("T")[0] +
      " " +
      dt.toString().split("Z")[0].split("T")[1]
    );
  }

  monthStringify(month: number) {
    return month >= 10 ? month.toString() : `0${month}`;
  }
}



// WEBPACK FOOTER //
// ./src/providers/utility/date-service/date-service.ts